/**
 * Asynchronously loads the component for DealerSendingCalendarSettingsComponent
 */

import { lazyLoad } from 'utils/loadable';

export const DealerSendingCalendarSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.DealerSendingCalendarSettingsComponent,
);
